// extracted by mini-css-extract-plugin
export default {"categories":"Categories_categories__cZBos","categories_item":"Categories_categories_item__u9Ak7","categories_active":"Categories_categories_active__X7Lit"};